@if (!editMode && selectedSkillLevel) {
  @if (selectedSkillLevel.rank == 0) {
    <span>N/A</span>
  }
  @if (selectedSkillLevel.rank != 0) {
    <div
      class="readonly-skills"
      [matTooltip]="getTooltipValue(selectedSkillLevel)"
    >
      @for (i of [1, 2, 3, 4, 5]; track i) {
        <div
          class="level readonly"
          [class.highlighted]="selectedSkillLevel.rank >= i"
        ></div>
      }
    </div>
  }
}
@if (editMode && skillLevels.length) {
  <div class="editable-skills-container">
    <div
      class="editable-skills"
      [class.error]="hasError"
      (mouseleave)="onMouseLeave()"
      attr.aria-labelledby="{{ ariaLabelledby }}"
    >
      @for (skillLevel of skillLevels; track skillLevel.id; let i = $index) {
        <div
          [attr.aria-label]="getValue(skillLevel)"
          (mouseenter)="onMouseHover(skillLevel)"
          (click)="onClick(skillLevel)"
          (keydown)="keyDown($event, i)"
          id="{{ skillLevel.id }}"
          class="level edit-mode"
          [class.na]="skillLevel.rank == 0"
          [class.highlighted]="
            hoveredSkillLevel && hoveredSkillLevel.rank >= i && i != 0
          "
          [class.selected]="
            selectedSkillLevel &&
            selectedSkillLevel.rank >= i &&
            (!hoveredSkillLevel || hoveredSkillLevel.rank >= i) &&
            i != 0
          "
          [class.selected-na]="
            selectedSkillLevel && selectedSkillLevel.rank == 0 && i == 0
          "
          tabindex="0"
        >
          {{ skillLevel.rank == 0 ? 'N/A' : '' }}
        </div>
      }
      @if (selectedSkillLevel) {
        <button
          mat-flat-button
          class="skill-delete-button"
          (click)="onDeleteSkill()"
          matTooltip="Delete skill value"
          aria-label="Delete skill value"
        >
          <mat-icon>delete</mat-icon>
        </button>
      }
    </div>
    @if (hoveredSkillLevel && hoveredSkillLevel.rank != 0) {
      <div class="skill-desc">
        {{ getValue(hoveredSkillLevel) }}
      </div>
    }
    @if (
      !hoveredSkillLevel && selectedSkillLevel && selectedSkillLevel.rank != 0
    ) {
      <div class="skill-desc">
        {{ getValue(selectedSkillLevel) }}
      </div>
    }
    <mat-error class="mat-error-skill" [class.error]="hasError">{{
      errorMessage
    }}</mat-error>
  </div>
}
